import { from, of, Observable } from 'rxjs'
import { mergeMap, catchError } from 'rxjs/operators'
import { afterAllTypes } from '../../../../lib/observables'
import * as actionTypes from '../../../constants/actionTypes'
import { setMessageCode } from '../../../actions/room/room'
import setupActions from '../../../actions/setup'
import { Room } from 'twilio-video'
import { setRoomError } from '../../../actions/setup/setupActions'
import { debug } from '@bt-react/libs/Logger'

const fetchRoom$ = (actions$, state, { twilioVideoConnect, getPresenterCount, checkRoomAvailability }) => actions$.pipe(
  afterAllTypes(
    actionTypes.SET_UI_DOCUMENT_STATE_COMPLETE,
    actionTypes.SET_BOOKING_DOCUMENT_STATE_COMPLETE,
    actionTypes.SET_ROLE,
    actionTypes.JOIN_ROOM
  ),
  mergeMap(() => from<Observable<Room>>(twilioVideoConnect(
    state.value.config.token, {
      username: state.value.config.username,
      roomname: state.value.config.roomname
    }
  )).pipe(
    mergeMap((room: Room) => {

      debug(`Connected to Room ${state.value.config.roomname} as ${state.value.config.username}`)

      const { username, maxPresenters } = state.value.config

      /** Get the number of presenters */
      const presenterCount = getPresenterCount(room, username)

      /** Check if the user should have access to the room */
      if (checkRoomAvailability(presenterCount, maxPresenters, username)) return of(setupActions.setRoom(room))

      /** The role shouldn't have access so disconnect and set the error message */
      room.disconnect()
      return of(setMessageCode(2015))

    }),
    catchError(() => of(setRoomError()))
  )
  )
)

export default fetchRoom$
